let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1n8PZ")).then(() => parcelRequire('5ExgM'));